export default function SvgIncomplete() {
    return <svg fill="none" viewBox="0 0 18 18" height="20" width="20" xmlns="http://www.w3.org/2000/svg" class="q-mr-xs" data-v-6a9d7b17="">
        <circle xmlns="http://www.w3.org/2000/svg" cx="9" cy="9" r="8" stroke="#DADDEC"></circle>
    </svg>;
}